import { createAction, props } from '@ngrx/store';
import { ApplicationVersionState } from '../state/application-version.state';

export const updateApplicationVersionState = createAction(
	'[app version] Update',
	props<{ appVersion: ApplicationVersionState }>(),
);
